import React, { useContext, createContext } from "react";
import axiosFactory, { METHOD_GET, METHOD_POST } from "../helpers/AxiosFactory";
import {
  GET_ALL_PUBLISHED_QUESTIONS,
  GET_QUESTION_BY_ID,
  GET_QUESTION_RELATED,
  GET_QUESTIONS_BY_FILTERS,
  ASK_QUESTION,
  EDIT_QUESTION,
  DELETE_QUESTION,
  ANSWER_QUESTION,
  DELETE_ANSWER,
  EDITE_ANSWER,
  GET_QUESTIONS_ANSWERED_BY_ME
} from "../helpers/UrlConstants";
const QuestionContext = createContext();
export function useQuestionContext() {
  return useContext(QuestionContext);
}
export default function QuestionProvider({ children }) {
  async function getQuestionsById(data) {
    return await axiosFactory({
      url: GET_QUESTION_BY_ID,
      method: METHOD_POST,
      data: data
    });
  }
  async function getQuestionRelated(data) {
    return await axiosFactory({
      url: GET_QUESTION_RELATED,
      method: METHOD_POST,
      data: data
    });
  }
  async function getAllPublishedQuestions(limit) {
    return await axiosFactory({
      url: GET_ALL_PUBLISHED_QUESTIONS,
      method: METHOD_POST,
      data: limit
    });
  }
  async function getQuestionsByFilter(data) {
    return await axiosFactory({
      url: GET_QUESTIONS_BY_FILTERS,
      method: METHOD_POST,
      data: data
    });
  }
  async function askQuestion(data) {
    return await axiosFactory({
      url: ASK_QUESTION,
      method: METHOD_POST,
      data: data
    });
  }
  async function editQuestion(data) {
    return await axiosFactory({
      url: EDIT_QUESTION,
      method: METHOD_POST,
      data: data
    });
  }
  async function answerQuestion(data) {
    return await axiosFactory({
      url: ANSWER_QUESTION,
      method: METHOD_POST,
      data: data
    });
  }
  async function deleteQuestion(data) {
    return await axiosFactory({
      url: DELETE_QUESTION,
      method: METHOD_POST,
      data: data
    });
  }
  async function editeAnswer(data) {
    return await axiosFactory({
      url: EDITE_ANSWER,
      method: METHOD_POST,
      data: data
    });
  }
  async function deleteAnswer(data) {
    return await axiosFactory({
      url: DELETE_ANSWER,
      method: METHOD_POST,
      data: data
    });
  }
  async function getQuestionsAnsweredByMe() {
    return await axiosFactory({
      url: GET_QUESTIONS_ANSWERED_BY_ME,
      method: METHOD_GET,
    });
  }

  const value = {
    getQuestionRelated,
    getQuestionsAnsweredByMe,
    getAllPublishedQuestions,
    getQuestionsById,
    getQuestionsByFilter,
    askQuestion,
    editQuestion,
    deleteQuestion,
    answerQuestion,
    deleteAnswer,
    editeAnswer
  };
  return (
    <QuestionContext.Provider value={value}>
      {children}
    </QuestionContext.Provider>
  );
}
